'use client';

import { PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import PlanCardsModule from '../PlanCards';
import HeroPricingModule from '../HeroPricing';
import { useState } from 'react';
import { PricingFrequencyContext } from './PricingFrequencyContext';
import Container from '@ui/Container/Container';

type Props = {
  data: PricingMainType;
};

const PricingMainModule = ({ data }: Props) => {
  const [isYearlyFrequency, setIsYearlyFrequency] = useState(true);

  return (
    <>
      <PricingFrequencyContext.Provider value={{ isYearlyFrequency, setIsYearlyFrequency }}>
        <Container>
          <HeroPricingModule data={data} />
          <PlanCardsModule data={data} />
        </Container>
      </PricingFrequencyContext.Provider>
    </>
  );
};

export default PricingMainModule;
